<template>
  <!-- TODO: for flexibility this component should not determine columns within -->
  <el-col
    :sm="24"
    :md="12"
    :lg="8"
    :xl="6"
    class=""
  >
    <el-card class="member-card box-card text-center h-100">
      <user-avatar
        shape="circle"
        :author-exist="!!member"
        :size="74"
        :src="member.avatar"
        :alt="member ? member.fullname : '' + 'Profile picture'"
        :show-label="true"
      ></user-avatar>


      <div class="name-position">
        <h2 class="text-truncate">
          {{ member.full_name }}
        </h2>

        <div
          class="d-flex justify-content-center flex-column"
        >
          <p class="text-truncate">
            {{ member.expertProfile.role }} 
          </p>
          <p class="text-truncate">{{ member.expertProfile.organisation_name }}</p>
        </div>
      </div>
      <hr class="mt-3 mb-3" />
      <div class="location-sectors">
        <div class="sectors d-flex justify-content-center sectors-text">
          <p class="text-truncate">
            {{ expertiseText }}
          </p>
          <span v-if="member.expertProfile.expertise.data.length > 2">+{{ member.expertProfile.expertise.data.length - 2 }} more</span>
        </div>
      </div>
      <div
        v-if="showProfileLink"
        class="view-profile-link"
      >
        <router-link
          :to="{ name: 'Member Profile', params: { id: member.id, showBackToSearch: true } }"
        >
          <span>
            View
            <span class="sr-only">
              {{ member.full_name }}'s
            </span>
            profile
          </span>
          <svg-purple-arrow-right class="arrow" />
        </router-link>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import PurpleArrowRight from '@/components/assets/svg-purple-arrow-right'
import UserAvatar from '@/components/core/user-avatar'
export default {
  name: 'MemberCard',
  components: {
    'svg-purple-arrow-right': PurpleArrowRight,
    UserAvatar
  },
  props: {
    member: {
      type: Object,
      required: true
    },
    showProfileLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    expertiseText() {

      let expertise = this.member.expertProfile?.expertise?.data;

      if (expertise.length >= 2 ) {
        return expertise[0].name + ", " + expertise[1].name;
      } else if (expertise.length == 1  ) {
        return expertise[0].name;
      } else {
        return "";
      }
    }
  },
};
</script>